import { render, staticRenderFns } from "./Modal_Muestreos.vue?vue&type=template&id=2ab20439&"
import script from "./Modal_Muestreos.vue?vue&type=script&lang=js&"
export * from "./Modal_Muestreos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports